import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=9bf9ad76&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=9bf9ad76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf9ad76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bf9ad76')) {
      api.createRecord('9bf9ad76', component.options)
    } else {
      api.reload('9bf9ad76', component.options)
    }
    module.hot.accept("./ForgetPassword.vue?vue&type=template&id=9bf9ad76&scoped=true", function () {
      api.rerender('9bf9ad76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/ForgetPassword.vue"
export default component.exports